import { IPanelOpenedSetAction } from './types';
import { AT_PANEL_OPENED_SET } from './constants';

export const panelOpenedSet = (
    isOpened: boolean
): IPanelOpenedSetAction => ({
    type: AT_PANEL_OPENED_SET,
    isOpened
});
